import * as React from 'react';
import { Button } from 'react-bootstrap';

import { SCREEN_BREAKPOINT_XL } from 'af-constants/values';

import Tooltip from 'af-components/Tooltip';

interface OwnProps {
	isShowNotesActive: boolean;
	toggleShowNotesMode: () => void;
}

type Props = OwnProps;

const ShowAddressNotesButton: React.FC<Props> = (props) => {
	const { toggleShowNotesMode, isShowNotesActive } = props;

	const [isButtonSmall, setIsButtonSmall] = React.useState(window.innerWidth < SCREEN_BREAKPOINT_XL);

	const updateWindowDimensions = React.useCallback(() => {
		const newIsButtonSmall = window.innerWidth < SCREEN_BREAKPOINT_XL;

		if (isButtonSmall !== isButtonSmall) {
			setIsButtonSmall(newIsButtonSmall);
		}
	}, [isButtonSmall]);

	// On mount
	React.useEffect(() => {
		updateWindowDimensions();
		window.addEventListener('resize', updateWindowDimensions);

		return () => {
			window.removeEventListener('resize', updateWindowDimensions);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			{
				isButtonSmall
					? (
						<Tooltip message={`${isShowNotesActive ? 'Hide' : 'Show'} Address Notes`}>
							<Button className={`btn--icon ${isShowNotesActive ? 'btn-info--blue-fill' : ''}`} onClick={toggleShowNotesMode} variant="info">
								<span className="icon-file-marker-outline" />
							</Button>
						</Tooltip>
					)
					: (
						<Button className={isShowNotesActive ? 'btn-info--blue-fill' : ''} onClick={toggleShowNotesMode} variant="info">
							<span className="icon-file-marker-outline m-r-xs" />
							Show Address Notes
						</Button>
					)
			}
		</>
	);
};

export default React.memo(ShowAddressNotesButton);
